import FeedbackPage from './FeedbackPage';

export * from './FeedbackPage.styles';
export default FeedbackPage; 